import React from 'react';
import { styled } from '@material-ui/core';
import { When } from 'UI/components/atoms';

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateRows: 'auto auto 1fr',
  height: '100%',
  gap: theme.spacing(1),
  overflow: 'hidden',
  '& > .footer': {
    overflowY: 'auto',
    scrollbarWidth: 'auto',
    '&::-webkit-scrollbar': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent !important'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 6,
      border: '3px solid transparent',
      backgroundClip: 'content-box'
    }
  }
}));

export const DetailPanelLayout = ({ header, body, footer }) => {
  return (
    <MainContainer>
      <div>{header}</div>
      <When condition={body}>
        <div>{body}</div>
      </When>
      <When condition={footer}>
        <div className="footer">{footer}</div>
      </When>
    </MainContainer>
  );
};
